const rules = {
  required(value) {
    return ['', null, undefined].indexOf(value) === -1
  },

  'required-select'(value) {
    return value !== 0
  },

  requiredSelect(value) {
    return value !== 0
  },

  'required-radio'(value) {
    return value !== 0
  },

  requiredRadio(value) {
    return value !== 0
  },

  'required-checkbox'(value) {
    return value === true
  },

  requiredCheckbox(value) {
    return value === true
  },
}

export default function installCustomRules(defineRule) {
  Object.keys(rules).forEach(ruleName => {
    defineRule(ruleName, rules[ruleName])
  })
}
